import productConstants from '@utils/constants/product';
import apiUtils from '@utils/apiUtils';
import { getTypesById as getProductById } from '@utils/productUtils';
import { apiConstants } from '../utils/constants';
import { fetchAPI, getApiSecuredHeaders } from './apiServiceHelper';
import dateUtils from '@/utils/dateUtils';

// Mockup Data
// import { hotelPriceRulesCreate } from './mockData/apiServiceMockupData';
// const hotelPriceRulesMockup = hotelPriceRulesCreate( );

const defaultGetParam = apiUtils.getDefaultGetParams();
const productHotelName = getProductById(productConstants.TYPE.HOTEL).type.toLocaleUpperCase();

let api = {
    priceRules: {
        hotel: {
            get: ({ filter, offset = defaultGetParam.offset, limit = defaultGetParam.limit }) => {
                const filterApi = {
                    from: filter.ruleDateFrom
                        ? dateUtils.formatQueryParam(filter.ruleDateFrom)
                        : undefined,
                    to: filter.ruleDateTo
                        ? dateUtils.formatQueryParam(filter.ruleDateTo)
                        : undefined,
                    activationFrom: filter.activationDateFrom
                        ? dateUtils.formatQueryParamDateBeginDayUTC(filter.activationDateFrom)
                        : undefined,
                    activationTo: filter.activationDateTo
                        ? dateUtils.formatQueryParamDateEndDayUTC(filter.activationDateTo)
                        : undefined,
                    ruleIds: filter.rules.length
                        ? filter.rules.map((item) => item.id).join(',')
                        : undefined,
                    partnerIds: undefined,
                    statuses:
                        Array.isArray(filter.statuses) && filter.statuses.length
                            ? filter.statuses.map((item) => item.value).join(',')
                            : undefined,
                    country:
                        filter.location.country && filter.location.country.code
                            ? filter.location.country.code
                            : undefined,
                    state:
                        filter.location.state && filter.location.state.code
                            ? filter.location.state.code
                            : undefined,
                    city:
                        filter.location.city && filter.location.city.name
                            ? filter.location.city.name
                            : undefined,
                };

                return fetchAPI.getList(`${apiConstants.BASE_URL}/api/price-rule`, {
                    ...filterApi,
                    limit,
                    offset,
                });
            },
            one: (id) => {
                return fetchAPI.get(`${apiConstants.BASE_URL}/api/price-rule/${id}`);
            },
            getLookup: ({ limit, offset }) => {
                return fetchAPI.getList(`${apiConstants.BASE_URL}/api/price-rule`, {
                    limit,
                    offset,
                });
            },
            activate: (id, data) => {
                const config = {
                    method: 'PATCH',
                    headers: getApiSecuredHeaders(),
                    responseType: 'json',
                    data: data,
                };
                return fetchAPI
                    .request(`${apiConstants.BASE_URL}/api/price-rule/activate/${id}`, config)
                    .then(apiUtils.checkStatus)
                    .catch((error) => {
                        return { ...apiUtils.checkError(error), rules: error.response.data.rules };
                    });
            },
            deactivate: (id) => {
                return fetchAPI.patch(`${apiConstants.BASE_URL}/api/price-rule/deactivate/${id}`);
            },
            create: (rule) => {
                const getStartDate = (date) => {
                    if (dateUtils.isToday(date)) {
                        return new Date();
                    }
                    if (dateUtils.isDateAfterTomorrowStartDay(date)) {
                        return dateUtils.getStartOfDay(date);
                    }

                    return date;
                };

                const payload = {
                    name: rule.ruleName,
                    description: rule.description,
                    from: dateUtils.formatQueryParam(getStartDate(rule.ruleDatesRange.start)),
                    to: dateUtils.formatQueryParam(rule.ruleDatesRange.end),
                    ruleType: rule.ruleType.value,
                    productType: productHotelName,
                    location: {
                        country: rule.location.country.code,
                        state: rule.location.state ? rule.location.state.code : null,
                        city: rule.location.city ? rule.location.city.name : null,
                    },
                    venueId: 0,
                    eventId: 0,
                    hotelId: 0,
                    action: {
                        referencePrice: rule.referencePrice.value,
                        value: rule.value,
                        currency: 'USD', //TODO this need to be remove
                        valueType: rule.valueType.value,
                        operation: rule.operationType.value,
                    },
                };

                return fetchAPI.post(`${apiConstants.BASE_URL}/api/price-rule`, payload);
            },
            update: (id, rule) => {
                const payload = {
                    id: id,
                    name: rule.ruleName,
                    description: rule.description,
                    from: dateUtils.formatQueryParam(rule.ruleDatesRange.start),
                    to: dateUtils.formatQueryParam(rule.ruleDatesRange.end),
                    ruleType: rule.ruleType.value,
                    productType: productHotelName,
                    location: {
                        country: rule.location.country.code,
                        state: rule.location.state ? rule.location.state.code : null,
                        city: rule.location.city ? rule.location.city.name : null,
                    },
                    venueId: 0,
                    eventId: 0,
                    hotelId: 0,
                    action: {
                        referencePrice: rule.referencePrice.value,
                        value: rule.value,
                        currency: 'USD', //TODO this need to be remove
                        valueType: rule.valueType.value,
                        operation: rule.operationType.value,
                    },
                };

                return fetchAPI.put(`${apiConstants.BASE_URL}/api/price-rule`, payload);
            },
        },
    },
};

export default api;
